import { Injectable } from '@angular/core';
import { LocalStorageService } from '@app/shared/services/local-storage';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  constructor(private readonly storage: LocalStorageService) {}

  public getAccessToken(): string | null {
    return this.storage.find(ACCESS_TOKEN_KEY);
  }

  public getRefreshToken(): string | null {
    return this.storage.find(REFRESH_TOKEN_KEY);
  }

  public saveTokens(accessToken: string, refreshToken: string): void {
    this.storage.create(ACCESS_TOKEN_KEY, accessToken);
    this.storage.create(REFRESH_TOKEN_KEY, refreshToken);
  }

  public saveAccessToken(token: string): void {
    this.storage.create(ACCESS_TOKEN_KEY, token);
  }

  public clearTokens(): void {
    if (this.storage.find(ACCESS_TOKEN_KEY)) {
      this.storage.remove(ACCESS_TOKEN_KEY);
    }
    if (this.storage.find(REFRESH_TOKEN_KEY)) {
      this.storage.remove(REFRESH_TOKEN_KEY);
    }
  }
}
